/**
 * Small circular score indicator (0–100). Uses avg assessment score or any 0–100 value.
 */
export default function ScoreRing({ value, label, size = 44 }) {
  const r = 16;
  const stroke = 3.5;
  const cx = size / 2;
  const cy = size / 2;
  const circ = 2 * Math.PI * r;
  const v = value == null || Number.isNaN(Number(value)) ? null : Math.min(100, Math.max(0, Number(value)));
  const offset = v == null ? circ : circ * (1 - v / 100);

  // The stroke colour carries meaning, so it has to be in the accessible name too.
  const band = v == null ? null : v >= 65 ? 'strong' : v >= 40 ? 'moderate' : 'low';
  const accessibleLabel = v == null
    ? `${label ? `${label}: ` : ''}Score not available`
    : `${label ? `${label}: ` : ''}Score ${Math.round(v)} out of 100, ${band}`;

  return (
    <div className="inline-flex items-center gap-2">
      <svg
        width={size}
        height={size}
        role="img"
        aria-label={accessibleLabel}
        className="flex-shrink-0"
      >
        <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e5e7eb" strokeWidth={stroke} />
        {v != null && (
          <circle
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke={v >= 65 ? '#0d9488' : v >= 40 ? '#f59e0b' : '#ef4444'}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circ}
            strokeDashoffset={offset}
            transform={`rotate(-90 ${cx} ${cy})`}
          />
        )}
        <text
          x={cx}
          y={cy + 4}
          textAnchor="middle"
          className="text-[10px] font-semibold fill-gray-700"
        >
          {v == null ? '—' : Math.round(v)}
        </text>
      </svg>
      {label && <span className="text-xs text-gray-500" aria-hidden="true">{label}</span>}
    </div>
  );
}
